module.exports = __webpack_public_path__ + "img/stick-around.ced315e1.png";